export const TOKEN = "Authorization";
export const USER = "User";
export const IDUSER = "idUser";
export const ROL = "rol";
export const USERNAME = "username";
export const PERMISSIONS = "permissions";
// Modelo de membresías: empresa (tenant) activa del usuario logueado.
export const COMPANY_ID = "companyId";
export const COMPANY_NAME = "companyName";

export const getStorageItems = () => {
  const token = sessionStorage.getItem(TOKEN);
  if (!token || token === "undefined" || token === "null") {
    return {};
  }
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const returnRol = () => {
  return sessionStorage.getItem(ROL);
};
